import React from 'react';
import { Routes } from 'react-router-dom';
import { USE_BETA_SCREENS } from '../../../../config/environment';
import { useBetaHook } from '../../hooks';

type Props = {
  regularRoutes: React.ReactNode;
  betaRoutes: React.ReactNode;
};

const BetaRouteSwitch = ({ regularRoutes, betaRoutes }: Props) => {
  const isBetaScreensFeatureEnabled = USE_BETA_SCREENS?.toLowerCase() === 'true';
  const { areBetaScreensEnabled } = useBetaHook();

  return (
    <Routes>
      {isBetaScreensFeatureEnabled
        ? areBetaScreensEnabled
          ? betaRoutes
          : regularRoutes
        : regularRoutes}
    </Routes>
  );
};

export default BetaRouteSwitch;
